module.exports = __webpack_public_path__ + "img/empty-icon.e6e08a5f.svg";